import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-subtitle1" }, " Select clients to assign them to the user. ", -1)
const _hoisted_2 = { class: "text-center q-mt-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_client_search_input = _resolveComponent("client-search-input")!
  const _component_unassigned_clients_table = _resolveComponent("unassigned-clients-table")!
  const _component_async_btn = _resolveComponent("async-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_client_search_input, {
      modelValue: _ctx.keyword,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keyword) = $event)),
      filled: "",
      outlined: "",
      dense: ""
    }, null, 8, ["modelValue"]),
    _createVNode(_component_unassigned_clients_table, {
      "user-id": _ctx.user.id,
      keyword: _ctx.keyword,
      selected: _ctx.selected,
      "onUpdate:selected": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selected) = $event)),
      class: "q-mt-md",
      ref: "clients"
    }, null, 8, ["user-id", "keyword", "selected"]),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createVNode(_component_async_btn, {
        task: _ctx.task,
        label: "Assign",
        color: "primary",
        onClick: _ctx.assign
      }, null, 8, ["task", "onClick"]), [
        [_vShow, _ctx.selected.length]
      ])
    ])
  ]))
}